import React, { Component } from "react";
import OptionDetails from "../optionDetails/OptionDetails";

class DealerOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditEnabled: false,
      inEditMode: false,
      individualEditIndex: -1,
      individualEditEnabled: false,
    };

    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.updateEditFlag = this.updateEditFlag.bind(this);
    this.updateIndividualEditIndex = this.updateIndividualEditIndex.bind(this);
    this.updateEnabledIndividualEdit =
      this.updateEnabledIndividualEdit.bind(this);
  }

  updateEditFlag(value) {
    this.setState({ isEditEnabled: value });
  }

  updateIndividualEditIndex(index) {
    this.setState({ individualEditIndex: index });
  }

  updateEnabledIndividualEdit(value) {
    this.setState({ individualEditEnabled: value });
  }

  toggleEditMode() {
    this.setState({ inEditMode: !this.state.inEditMode });
  }

  render() {
    return (
      <OptionDetails
        {...this.props}
        isDealer={true}
        inEditMode={this.state.inEditMode}
        toggleEditMode={this.toggleEditMode}
        isEditEnabled={this.state.isEditEnabled}
        updateEditFlag={this.updateEditFlag}
        updateIndividualEditIndex={this.updateIndividualEditIndex}
        updateEnabledIndividualEdit={this.updateEnabledIndividualEdit}
        individualEditIndex={this.state.individualEditIndex}
        individualEditEnabled={this.state.individualEditEnabled}
      />
    );
  }
}

export default DealerOptions;
